/*
 * Agenda React — le gros du style provient des feuilles existantes enqueuées
 * côté PHP (gas-agenda.css + gas-card.css), réutilisées via les mêmes classes
 * BEM gas-agenda__* / gas-card. Styles d'appoint uniquement ici.
 */
.gas-agenda__loading {
    padding: var(--gas-space-2xl);
    text-align: center;
    color: var(--gas-text-color-light);
}
